import { z } from 'zod';
import { USER_ROLES } from '../enums';

export const userRoleSchema = z.enum(USER_ROLES);

export const createUserInputSchema = z.object({
  username: z
    .string()
    .min(3)
    .max(50)
    .regex(/^[a-zA-Z0-9._-]+$/),
  password: z.string().min(8).max(200),
  fullName: z.string().min(1).max(100),
  role: userRoleSchema,
  employeeId: z.string().uuid().optional(),
  active: z.boolean().default(true),
});
export type CreateUserInput = z.infer<typeof createUserInputSchema>;

export const updateUserInputSchema = createUserInputSchema
  .partial()
  .omit({ password: true })
  .extend({
    /** New password (optional — only if changing). */
    newPassword: z.string().min(8).max(200).optional(),
  });
export type UpdateUserInput = z.infer<typeof updateUserInputSchema>;

export const userPublicSchema = z.object({
  id: z.string().uuid(),
  username: z.string(),
  fullName: z.string(),
  role: userRoleSchema,
  employeeId: z.string().uuid().nullable(),
  active: z.boolean(),
  createdAt: z.string().datetime(),
});
export type UserPublic = z.infer<typeof userPublicSchema>;
